export default __webpack_public_path__ + "static/iris-6da50dd8f6c4836dde7e7a9bb2166139.png";